
const firebaseConfig = {
    apiKey: "AIzaSyClDD9RgnxuUL1eu6kDKLb0nPluIbPbRnc",
    authDomain: "luxury-hotel-a1d89.firebaseapp.com",
    projectId: "luxury-hotel-a1d89",
    storageBucket: "luxury-hotel-a1d89.appspot.com",
    messagingSenderId: "155033469406",
    appId: "1:155033469406:web:d2774cf747a51d30705d4f"
};
// apiKey: process.env.REACT_APP_API_KEY,
// authDomain: process.env.REACT_APP_AUTH_DOMAIN,
// projectId: process.env.REACT_APP_PROJECT_ID,
// storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
// messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
// appId: process.env.REACT_APP_APP_ID,

export default firebaseConfig;